import { MenuIdHome } from '@jira/navigation-apps__constants/src/MenuIdHome.tsx';
import { getAutomationDiscoveryDismissResource } from '@jira/router-resources__eoc-alert-detail/src/getAutomationDiscoveryDismissResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyGlobalAlertsSidebar } from '@jira/navigation-apps__sidebar-eoc-global-alerts/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocGlobalAlertsDetailRoute } from '@jira/router-routes__eoc-global-alerts-routes/src/eocGlobalAlertsDetailRoute.tsx';
import { resources as alertListResources } from '@atlassian/eoc-alert-list/resources';
import { resources as alertDetailResources } from '@atlassian/eoc-alert-detail/resources';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { AlertListComponent, LazyAlertList } from './ui/AlertListComponent.tsx';

export const eocGlobalAlertsDetailRouteEntry: Route = createEntry(
	eocGlobalAlertsDetailRoute,
	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: AlertListComponent,

		resources: [
			...getNavigationResources(),
			...alertListResources(),
			...alertDetailResources(),
			getConsolidationStateResource(),
			resourceWithCondition(
				() => fg('automation_discoverability_in_jsm'),
				getAutomationDiscoveryDismissResource,
			),
		],

		navigation: {
			menuId: MenuIdHome,
		},

		forPaint: [LazyAtlassianNavigation, LazyAlertList, LazyGlobalAlertsSidebar],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
